import Modal from 'bootstrap/js/dist/modal';

const DEFAULT_HOSTS = ['erejestracja.net'];

const getConfiguredHosts = () => {
  const localizedHosts = window.applvrExternalRedirect && window.applvrExternalRedirect.hosts;

  return Array.isArray(localizedHosts) && localizedHosts.length ? localizedHosts : DEFAULT_HOSTS;
};

const isExternalBookingUrl = (href) => {
  let url;

  try {
    url = new URL(href, window.location.origin);
  } catch (error) {
    return false;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return false;
  }

  return getConfiguredHosts().some((host) => {
    return url.hostname === host || url.hostname.slice(-host.length - 1) === `.${host}`;
  });
};

const initExternalRedirectNotice = () => {
  const modalEl = document.getElementById('external-redirect');

  if (!modalEl) {
    return;
  }

  const modal = Modal.getOrCreateInstance(modalEl);
  const hostLabel = modalEl.querySelector('[data-external-redirect-host]');
  const confirmButton = modalEl.querySelector('[data-external-redirect-confirm]');
  const pending = {
    href: '',
    target: '',
  };

  const openNotice = (link) => {
    let url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    pending.href = url.href;
    pending.target = link.getAttribute('target') || '';

    if (hostLabel) {
      hostLabel.textContent = url.hostname;
    }

    modal.show();
  };

  const continueToBooking = () => {
    const { href, target } = pending;

    if (!href) {
      return;
    }

    if (target === '_blank') {
      window.open(href, '_blank', 'noopener,noreferrer');
      modal.hide();
      return;
    }

    window.location.assign(href);
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) {
      return;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (!link || !isExternalBookingUrl(link.href)) {
      return;
    }

    event.preventDefault();
    openNotice(link);
  });

  confirmButton?.addEventListener('click', (event) => {
    event.preventDefault();
    continueToBooking();
  });
};

export { initExternalRedirectNotice };
